export const state = () => ({
  logos: [],
})

export const mutations = {
  setLogos(state, favourites) {
    state.logos = favourites
  },

  reset(state) {
    state.logos = []
  },
}

export const getters = {
  isLiked: state => logo => state.logos.find(({ id }) => id === logo.id),
}

export const actions = {
  async fetchFavouriteLogos({ commit }) {
    try {
      const auth = await this.$getAuthInstance()
      const { attributes } = await auth.currentAuthenticatedUser()
      const { data } = await this.$api.get(
        `/api/v2/logos/favourites/user_${attributes.sub}`
      )

      commit('setLogos', data.data)
    } catch (error) {
      commit('setLogos', [])
      throw error
    }
  },

  addLogo({ state, commit, getters }, logo) {
    if (state.logos.length >= 20) {
      this.$toast.error(
        'You can only have 20 favorited logos.  Remove some logos from your favorites and try again.'
      )
      return
    }

    if (!getters.isLiked(logo)) {
      commit('setLogos', [...state.logos, logo])
    }
  },

  removeLogo({ state, commit, getters }, logo) {
    if (getters.isLiked(logo)) {
      commit(
        'setLogos',
        [...state.logos].filter(({ id }) => id !== logo.id)
      )
    }
  },
}
